import type { UserTransactionType } from '../HistoryOfTransactions'

export const splitByDates = (transactions: UserTransactionType[]) => {
  const groupedTransactions = transactions.reduce(
    (obj: { [key: string]: UserTransactionType[] }, transaction: UserTransactionType) => {
      const date = transaction.created_at.split('T')[0]

      if (!obj[date]) {
        obj[date] = []
      }

      obj[date].push(transaction)
      return obj
    },
    {},
  )

  const sortedTransactions = Object.keys(groupedTransactions).sort(
    (a, b) => new Date(b).getTime() - new Date(a).getTime(),
  )

  return sortedTransactions.map((date) => groupedTransactions[date])
}
